import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import { withTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';

import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import iconGetUp from '../../../../images/Presense/Action/icon-stand.png';
import iconJump from '../../../../images/Presense/Action/icon-jump.png';
import iconNoMovement from '../../../../images/Presense/Action/icon-nomovement.png';
import iconNosignal from '../../../../images/Presense/DeviceSignal/icon-nosignal.png';
import { notification } from 'antd';
import { getTimeFormatted, getAlertTime } from '../../../../utils/timeFormatted';
import moment from 'moment';
import { voteAlert } from '../../../../utils/voteAlert';
import config from '../../../../config';
import classnames from 'classnames';

const styles = (theme) => ({
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  columnWidth250: {
    // maxWidth: "250px",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 16,
  },

  columnWidth300: {
    display: 'flex',
    maxWidth: '230px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  tooltipFont: {
    fontSize: '15px',
  },
  buttonOption: {
    padding: '3px',
    margin: 2,
    color: theme.palette.success.main,
    backgroundColor: theme.palette.primary.bg,
    width: 26,
    height: 26,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
  displayButton: {
    padding: '3px',
    margin: 2,
    color: theme.palette.success.main,
    backgroundColor: theme.palette.primary.bg,
    width: 26,
    height: 26,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  buttonStatus: {
    width: 26,
    height: 26,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icongender: {
    fontSize: '16px',
    marginRight: theme.spacing.unit * 2,
    color: theme.palette.primary.main,
  },
  dialogMenu: {
    backgroundColor: 'rgba(9,30,66,0.13)',
    border: 0,
    height: '1px',
    margin: '11px',
    padding: 0,
    width: '84%',
  },
  tableCell: {
    padding: '4px',
    borderBottom: 'none',
  },
  tableCellHiding: {
    padding: '4px',
    borderBottom: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  tableCellOptions: {
    padding: '4px',
    borderBottom: 'none',
    paddingRight: '4px !important',
  },
  bodyTable: {
    borderTop: '1px solid #B8CFC3',
    height: 45,
  },
  iconsos: {
    width: 30,
  },
  iconColor: {
    color: theme.palette.success.main,
  },
  customStyleWithoutEmergency: {
    padding: 5,
    textAlign: 'center',
    width: '200px',
    fontSize: 14,
    backgroundColor: theme.palette.error.main,
    color: 'white',
  },
  customStyleflex: {
    display: 'flex',
    alignItems: 'center',
    // width: '300px',
  },
  customText: {
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: '10px'
}


});

class ContentRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clearAlert: false,
    };
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (nextProps.t !== this.props.t) {
      return true;
    }
    if (JSON.stringify(nextProps.data.device.action) !== JSON.stringify(this.props.data.device.action)) {
      return true;
    }
    if (JSON.stringify(nextProps.data.patient) !== JSON.stringify(this.props.data.patient)) {
      return true;
    }
    if (JSON.stringify(nextProps.data.roomName) !== JSON.stringify(this.props.data.roomName)) {
      return true;
    }
    if (JSON.stringify(nextProps.data.alert) !== JSON.stringify(this.props.data.alert)) {
      return true;
    }
    if (this.props.isMoreMenuOpen !== nextProps.isMoreMenuOpen) {
      return true;
    }
    if (this.state.clearAlert !== nextState.clearAlert) {
      return true;
    }
    return false;
  };

  acknowledge(bed) {
    this.props.dashboard.updateToken();
    this.props.dashboard.ackAlert(bed);
  }

  clearAlert(bed) {
    this.props.dashboard.updateToken();
    this.props.dashboard.clearAlert(bed);
    this.setState({
      clearAlert: !this.state.clearAlert,
    });
  }

  async chageActivate(patient) {
    let device = patient.devices;
    device.map((val) => {
      val.status = val.status === 'ACTIVATE_ON' ? 'ACTIVATE_OFF' : 'ACTIVATE_ON';
      return val;
    });
    try {
      await this.props.dashboard.assignDevice(device, patient.id);
    } catch (err) {
      notification.error({
        message: `error`,
        description: err.error.message,
        top: '100px',
      });
    }
  }

  accessibility = (activite) => {
    const { classes } = this.props;
    let result = '';
    switch (activite) {
      case 1:
      case 10:
      case 14:
      case 15:
      case 16:
      case 17:
        result = <Icons.LocalHotel className={classes.iconActivity} />;
        break;
      case 2:
        result = <Icons.AirlineSeatReclineNormal className={classes.iconActivity} />;
        break;
      case 3:
        // result = <Icons.Accessibility className={classes.iconActivity} />;
        result = <img src={iconGetUp} alt='getup' width='30' />;
        break;
      case 4:
        result = <Icons.DirectionsWalk className={classes.iconActivity} />;
        break;
      case 5:
        result = <Icons.DirectionsRun className={classes.iconActivity} />;
        break;
      case 6:
        result = <img src={iconJump} alt='jump' width='30' />;
        break;
      case 8:
        result = <Icons.BatteryAlert className={classes.iconActivity} />;
        break;
      case 504:
        result = <img src={iconNosignal} alt='nosignal' width='30' />;
        break;
      case 11:
        result = <img src={iconNoMovement} alt='nomovement' width='30' />;
        break;
      case 18:
        result = <Icons.TransferWithinAStation className={classes.iconActivity} />;
        break;
      case 19:
        result = <Icons.DirectionsWalk className={classes.iconActivity} />;
        break;
      case 100:
        result = <Icons.LocationOn className={classes.iconActivity} />;
        break;
      case 101:
        result = <Icons.NotificationsActive className={classes.iconActivity} />;
        break;
      default:
        result = <div className={classes.iconActivity} />;
        break;
    }
    return result;
  };

  getMomentValue = (value) => {
    const { t } = this.props;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('movement')}`;
        break;
      case 8:
        result = `${t('low_battery')}`;
        break;
      case 9:
        result = `${t('no_signal')}`;
        break;
      case 10:
        result = `${t('not_turn_for')}`;
        break;
      case 11:
        result = `${t('no_movement')}`;
        break;
      case 12:
        result = `${t('falling')}`;
        break;
      case 13:
        result = `${t('unknown')}`;
        break;
      case 14:
        result = `${t('lying_on_back')}`;
        break;
      case 15:
        result = `${t('lying_on_stomach')}`;
        break;
      case 16:
        result = `${t('lying_on_left_side')}`;
        break;
      case 17:
        result = `${t('lying_on_right_side')}`;
        break;
      case 18:
        result = `${t('out_of_area')}`;
        break;
      case 19:
        result = `${t('walking_at_night')}`;
        break;
      case 100:
        result = `${t('detect_location')}`;
        break;
      case 101:
        result = `${t('alert_emergency_alarm')}`;
        break;
      default:
        break;
    }
    return result;
  };

  battery = (level, timestamp) => {
    const { classes, t } = this.props;
    let result = '';
    if (level > 0 && level <= 20) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          {/* <Icons.BatteryAlert /> */}
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery10`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 20 && level <= 40) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          {/* <Icons.Battery30 className={classes.iconColor} /> */}
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery25`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 40 && level <= 50) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          {/* <Icons.Battery50 className={classes.iconColor} /> */}
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery50`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 50 && level <= 70) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          {/* <Icons.Battery60 className={classes.iconColor} /> */}
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery50`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 70 && level <= 80) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          {/* <Icons.Battery80 className={classes.iconColor} /> */}
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery75`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 80 && level <= 90) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          {/* <Icons.Battery90 className={classes.iconColor} /> */}
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery75`} />
          </svg>
        </Tooltip>
      );
    } else if (level > 90) {
      result = (
        <Tooltip
          title={`${level}% (${t('since')} ${getTimeFormatted(timestamp, t)})`}
          classes={{ tooltip: classes.tooltipFont }}
        >
          {/* <Icons.BatteryFull className={classes.iconColor} /> */}
          <svg viewBox='0 0 10 22' width='10' height='22'>
            <use xlinkHref={`/images/battery.svg#battery100`} />
          </svg>
        </Tooltip>
      );
    }
    return result;
  };

  getRouterPlace = (serial) => {
    const { routers } = this.props.router.toJS();
    const routerData = (routers || []).find((val) => val.serial === serial);
    if (routerData) {
      return routerData.place;
    }
  };

  getRouterArea = (serial) => {
    let { areas } = this.props.area.toJS();
    let name = '';
    (areas.data || []).map((val) => {
      const result = (val.routers || []).find((routers) => routers.serial === serial);
      if (result) {
        name = val.name;
      }
      return val;
    });
    return name;
  };

  getAlertInfo = (value, serial, time, alertAreaName) => {
    const { t } = this.props;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('lying_on_back')}`;
        break;
      case 8:
        result = `${t('lying_on_stomach')}`;
        break;
      case 9:
        result = `${t('lying_on_left_side')}`;
        break;
      case 10:
        result = `${t('lying_on_right_side')}`;
        break;
      case 501:
        result = `${t('get_up')}`;
        break;
      case 502:
        result = `${t('movement')}`;
        break;
      case 503:
        result = `${t('low_battery')}`;
        break;
      case 504:
        result = `${t('alert_last_seen')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 505:
        result = `${t('alert_router_no_signal')}`;
        break;
      case 506:
        result = `${t('alert_not_turn')}`;
        break;
      case 507:
        let numberOfDay = time / 60 / 24;
        let dayFormat = `${numberOfDay === 1 ? numberOfDay + ' ' + t('day') : numberOfDay + ' ' + t('days')}`;
        result = `${t('alert_no_movement')} > ${numberOfDay === 0 ? '' : dayFormat}`;
        break;
      case 508:
        result = `${t('alert_fall')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 509:
        result = ` @ ${t('alert_exit')} ${alertAreaName ? alertAreaName : this.getRouterArea(serial)}`;
        break;
      case 510:
        result = ` @ ${alertAreaName ? alertAreaName : this.getRouterArea(serial)}`;
        break;
      case 511:
        result = `${t('alert_walking')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 512:
        result = `${t('alert_deactivate_recharge')}`;
        break;
      case 513:
        result = `${t('alert_bad_signal')}`;
        break;
      case 514:
        result = `${t('alert_emergency_alarm')} ${
          config.displayPlaceForEmergency ? `@ ${this.getRouterPlace(serial)}` : ''
        }`;
        break;
      default:
        break;
    }
    return result;
  };

  isEmergencyButton = (devices) => {
    for (const device of devices || []) {
      const { deviceVersion } = device;
      if (deviceVersion) {
        const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
        if (property) {
          if (property.alarmTrigger || property.alarmOnoff) {
            return true;
          }
        }
      }
    }
    return false;
  };

  isEmergencyDevice = (device) => {
    const { deviceVersion } = device;
    if (deviceVersion) {
      const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
      if (property) {
        if (property.alarmTrigger || property.alarmOnoff) {
          return true;
        }
      }
    }
    return false;
  };

  // isMuted = (userWithAlert) => {
  //   let muteNotification = localStorage.getItem("mute_notification");
  //   muteNotification = muteNotification ? JSON.parse(muteNotification) : [];
  //   return muteNotification.find((val) => val.patientId === userWithAlert.patientId) ? true : false;
  // };

  isMuted = (userWithAlert) => {
    let muteNotification = localStorage.getItem('mute_notification');
    muteNotification = muteNotification ? JSON.parse(muteNotification) : [];
    const mutePatient = muteNotification.find((val) => val.patientId === userWithAlert.patientId);
    if (mutePatient) {
      if (
        userWithAlert &&
        userWithAlert.patient &&
        userWithAlert.patient.devices &&
        userWithAlert.patient.devices.length > 0
      ) {
        const alertIds = [];
        userWithAlert.patient.devices.forEach((d) => {
          if (d.action && d.action.alerts.length > 0) {
            d.action.alerts.forEach((a) => {
              if (a.alertId && a.alertType !== 513) {
                alertIds.push(a.alertId);
              }
            });
          }
        });
        const newAlertIds = alertIds.filter((x) => !(mutePatient.alertId || []).includes(x));

        return newAlertIds.length === 0 ? true : false;
      }
    }
    return false;
  };

  getColFullname = (patient) => {
    const { classes, t } = this.props;
    if (patient) {
      const dob = moment(new Date(patient.dob)).startOf('day');
      const now = moment(new Date());
      const age = now.diff(dob, 'year');

      // const ageDifMs = Date.now() - new Date(patient.dob).getTime();
      // const ageDate = new Date(ageDifMs); // miliseconds from epoch
      // const age = Math.abs(ageDate.getUTCFullYear() - 1970);
      let name = '';
      if (localStorage.getItem('i18nextLng') === 'th-TH') {
        if (patient.firstname || patient.lastname) {
          name = `${patient.firstname ?? ''} ${patient.lastname ?? ''}`;
        } else {
          name = `${patient.firstnameEn ?? ''} ${patient.lastnameEn ?? ''}`;
        }
      }
      if (localStorage.getItem('i18nextLng') === 'en-EN') {
        if (patient.firstnameEn || patient.lastnameEn) {
          name = `${patient.firstnameEn ?? ''} ${patient.lastnameEn ?? ''}`;
        } else {
          name = `${patient.firstname ?? ''} ${patient.lastname ?? ''}`;
        }
      }

      return (
        <div className={classes.columnWidth250}>
          <i
            className={
              patient.gender === 'M'
                ? `${classes.icongender} ${classes.iconColor} fa fa-mars`
                : `${classes.icongender} ${classes.iconColor} fa fa-venus`
            }
          />
          {name} {age ? `${age} ${t('yr')}` : ''}
        </div>
      );
    }
  };

  getColStatus = (data) => {
    const { classes, t } = this.props;
    const isDeviceExist = data.patient && data.patient.devices && data.patient.devices.length > 0;
    if (isDeviceExist) {
      // filter devices not sos
      const deviceWithOutEmergency =
        data.patient && data.patient.devices
          ? data.patient.devices.filter((d) => d.deviceVersion && d.deviceVersion.category !== 'EMERGENCY_BUTTON')
          : [];
      const isBadStatus =
        deviceWithOutEmergency &&
        deviceWithOutEmergency.length > 0 &&
        deviceWithOutEmergency.find((d) => {
          const result =
            d.status === 'ACTIVATE_OFF' ||
            (!d.action && d.status === 'ACTIVATE_ON') ||
            (d.action &&
              ((d.action.alerts && d.action.alerts.find((a) => a.alertType === 504 || a.alertType === 513)) ||
                d.action.nosignal === 'true' ||
                (d.action.changed && d.action.changed.a === null && d.status === 'ACTIVATE_ON')));
          return result;
        });

      return (
        <div
          className={classes.columnWidth200}
          id={data.patient ? `status-${data.patient.hn}` : `room${data.roomName}`}
          style={{ display: 'flex' }}
        >
          {deviceWithOutEmergency.length > 0 ? (
            <div>
              {deviceWithOutEmergency.length === 1 ? (
                <div>
                  {isBadStatus ? (
                    <Tooltip
                      title={`${t('since')} ${getTimeFormatted(
                        deviceWithOutEmergency[0].action && deviceWithOutEmergency[0].action.timestamp,
                        t,
                      )}`}
                      classes={{ tooltip: classes.tooltipFont }}
                    >
                      {/* <Icons.SignalWifiOff
                        style={{ marginLeft: 3, color: "#B4B4B4" }}
                      /> */}
                      <svg viewBox='0 0 30 27' width='24' height='24'>
                        <use xlinkHref={`/images/signal.svg#badsignal`} />
                      </svg>
                    </Tooltip>
                  ) : (
                    <div>
                      {deviceWithOutEmergency &&
                      deviceWithOutEmergency[0].action &&
                      deviceWithOutEmergency[0].action.changed &&
                      deviceWithOutEmergency[0].action.changed.b ? (
                        <div style={{ marginLeft: 6 }}>
                          {this.battery(
                            deviceWithOutEmergency[0].action.changed.b,
                            deviceWithOutEmergency[0].action.batteryTimestamp
                              ? deviceWithOutEmergency[0].action.batteryTimestamp
                              : deviceWithOutEmergency[0].action.timestamp,
                          )}
                        </div>
                      ) : (
                        <Tooltip title={t('signal')} classes={{ tooltip: classes.tooltipFont }}>
                          <svg viewBox='0 0 30 24' width='24' height='24'>
                            <use xlinkHref={`/images/signal.svg#goodsignal`} />
                          </svg>
                        </Tooltip>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {isBadStatus ? (
                    <IconButton
                      className={classes.buttonStatus}
                      aria-owns='more-menu'
                      aria-haspopup='true'
                      onClick={() => this.props.setOpenStatus(data.patientId)}
                    >
                      <Icons.Warning style={{ color: '#FFC260' }} />
                    </IconButton>
                  ) : (
                    <IconButton
                      className={classes.buttonStatus}
                      aria-owns='more-menu'
                      aria-haspopup='true'
                      onClick={() => this.props.setOpenStatus(data.patientId)}
                    >
                      <Icons.CheckCircle style={{ color: '#55C1B0' }} />
                    </IconButton>
                  )}
                </div>
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      );
    } else {
      return (
        <div
          className={classes.columnWidth200}
          id={data.patient ? `status-${data.patient.hn}` : `room${data.roomName}`}
        ></div>
      );
    }
  };

  getColAlert = (data ,votedAlert, customStyle) => {
    const { classes } = this.props;
    if (votedAlert) {
      const time = votedAlert.warningSetting.noMovementForTime;
      const alertType = votedAlert.alertType;
      const routerSerial = votedAlert.routerSerial;
      const alertAreaName = votedAlert.alertAreaName;
      return (
        <div
          className={classnames({
            [classes.customStyleWithoutEmergency]: alertType === 514,
          })}
          style={alertType !== 514 ? customStyle : {}}
        >
          {/* <div className={classes.columnWidth200}>
            {this.getAlertInfo(alertType, routerSerial, time, alertAreaName)}  
          </div> */}

          <div className={classes.customStyleflex}>
            <div className={classes.customText}>
            {this.getAlertInfo(alertType, routerSerial, time, alertAreaName)}
            </div>
            <div>{this.getColOptionsV2(data)}</div>
          </div>

        </div>
      );
    }
  };

  getColAlertTime = (data) => {
    const { classes, t } = this.props;
    return (
      <div>
        {data && (data.alertWarning === 'true' || data.alertCritical === 'true') && (
          <Tooltip title={moment(data.alertTime).format('DD/MM/YY HH:mm')} classes={{ tooltip: classes.tooltipFont }}>
            <div>{getAlertTime(data.alertTime, t)}</div>
          </Tooltip>
        )}
      </div>
    );
  };

  getColOptions = (data) => {
    const {
      classes,
      t,
      setMoreMenuOpen,
      handleClickOpenDialogAddPatient,
      // handleClickOpenDialogActivities,
      // handleClickOpenDialogContact,
    } = this.props;

    if (data.patient) {
      // const alert = voteAlert(data.patient);
      // const { votedAlert } = alert;
      return (
        <div className={classes.columnWidth200} style={{ display: 'flex', justifyContent: 'right' }}>
          {/* {votedAlert &&
            (votedAlert.alertWarning === 'true' || votedAlert.alertCritical === 'true') &&
            !this.isMuted(data) && (
              <Tooltip title={t('mute')} classes={{ tooltip: classes.tooltipFont }}>
                <IconButton
                  className={classes.displayButton}
                  aria-label='delete'
                  id={data.patient ? `clear-alert-${data.patient.hn}` : `clear-alert-${data.roomName}`}
                  onClick={() => this.clearAlert(data)}
                >
                  <svg viewBox='1 1 24 27' width='24'>
                    <use xlinkHref={`/images/menus-v1.svg#mute`} />
                  </svg>
                </IconButton>
              </Tooltip>
            )}

          {data.alert && data.alert.acknowledge === true && (
            <Tooltip title={t('acknowledge')} classes={{ tooltip: classes.tooltipFont }}>
              <IconButton
                className={classes.buttonOption}
                aria-label='delete'
                id={data.patient ? `acknowledge-alert-${data.patient.hn}` : `acknowledge-alert-${data.roomName}`}
                onClick={() => this.acknowledge(data)}
              >
                <svg width='21' height='21' viewBox='4 0 14 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M6.5 11L9 14L15.5 6' stroke='#00978F' strokeWidth='1.5' />
                </svg>
              </IconButton>
            </Tooltip>
          )} */}
          {data.patient.id && (
            <IconButton
              id={`vitalsign-${data.patient.hn}`}
              className={classes.displayButton}
              aria-owns='vital'
              aria-haspopup='true'
              onClick={() => this.props.handleClickOpenDialogVitalSigns(data.patient)}
            >
              <svg width='26' height='26' viewBox='0 0 26 26'>
                <use xlinkHref={`/images/vital.svg#vitalsigns`} />
              </svg>
            </IconButton>
          )}
          {
            data.patient.id && (
              <IconButton
                className={classes.buttonOption}
                aria-owns='more-menu'
                aria-haspopup='true'
                onClick={(e) => setMoreMenuOpen(e, data.patient)}
              >
                <svg viewBox='1 0 26 26' width='24'>
                  <use xlinkHref={`/images/menus-v1.svg#moremenus`} />
                </svg>
              </IconButton>
            )
          }
        </div>
      );
    } else {
      return (
        <div className={classes.columnWidth200} style={{ display: 'flex', justifyContent: 'right' }}>
          <Tooltip title={t('admit_patient')} classes={{ tooltip: classes.tooltipFont }}>
            <IconButton
              className={classes.buttonOption}
              aria-label='activate'
              onClick={() => handleClickOpenDialogAddPatient(data.id, data.subGroupId)}
              id={`admit-patient`}
            >
              <Icons.PersonAdd style={{ width: 18 }} />
            </IconButton>
          </Tooltip>
        </div>
      );
    }
  };

  getColOptionsV2 = (data) => {
    const {
      classes,
      t,
      // setMoreMenuOpen,
      handleClickOpenDialogAddPatient,
      // handleClickOpenDialogActivities,
      // handleClickOpenDialogContact,
    } = this.props;

    if (data.patient) {
      const alert = voteAlert(data.patient);
      const { votedAlert } = alert;
      return (
        <div className={classes.columnWidth200} style={{ display: 'flex', justifyContent: 'right' }}>
          {votedAlert &&
            (votedAlert.alertWarning === 'true' || votedAlert.alertCritical === 'true') &&
            !this.isMuted(data) && (
              <Tooltip title={t('mute')} classes={{ tooltip: classes.tooltipFont }}>
                <IconButton
                  className={classes.displayButton}
                  aria-label='delete'
                  id={data.patient ? `clear-alert-${data.patient.hn}` : `clear-alert-${data.roomName}`}
                  onClick={() => this.clearAlert(data)}
                >
                  <svg viewBox='1 1 24 27' width='24'>
                    <use xlinkHref={`/images/menus-v1.svg#mute`} />
                  </svg>
                </IconButton>
              </Tooltip>
            )}

          {data.alert && data.alert.acknowledge === true && (
            <Tooltip title={t('acknowledge')} classes={{ tooltip: classes.tooltipFont }}>
              <IconButton
                className={classes.buttonOption}
                aria-label='delete'
                id={data.patient ? `acknowledge-alert-${data.patient.hn}` : `acknowledge-alert-${data.roomName}`}
                onClick={() => this.acknowledge(data)}
              >
                <svg width='21' height='21' viewBox='4 0 14 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M6.5 11L9 14L15.5 6' stroke='#00978F' strokeWidth='1.5' />
                </svg>
              </IconButton>
            </Tooltip>
          )}
        </div>
      );
    } else {
      return (
        <div className={classes.columnWidth200} style={{ display: 'flex', justifyContent: 'right' }}>
          <Tooltip title={t('admit_patient')} classes={{ tooltip: classes.tooltipFont }}>
            <IconButton
              className={classes.buttonOption}
              aria-label='activate'
              onClick={() => handleClickOpenDialogAddPatient(data.id, data.subGroupId)}
              id={`admit-patient`}
            >
              <Icons.PersonAdd style={{ width: 18 }} />
            </IconButton>
          </Tooltip>
        </div>
      );
    }
  };

  getColOptionsSecurityGuard = (data) => {
    const { classes, t } = this.props;
    if (data.patient) {
      const alert = voteAlert(data.patient);
      const { votedAlert } = alert;
      return (
        <div className={classes.columnWidth200}>
          {votedAlert &&
            (votedAlert.alertWarning === 'true' || votedAlert.alertCritical === 'true') &&
            !this.isMuted(data) && (
              <Tooltip title={t('mute')} classes={{ tooltip: classes.tooltipFont }}>
                <IconButton
                  className={classes.buttonOption}
                  aria-label='delete'
                  id={data.patient ? `clear-alert-${data.patient.hn}` : `clear-alert-${data.roomName}`}
                  onClick={() => this.clearAlert(data)}
                >
                  <svg viewBox='1 1 24 27' width='26'>
                    <use xlinkHref={`/images/menus-v1.svg#mute`} />
                  </svg>
                </IconButton>
              </Tooltip>
              // <Tooltip
              //   title={t("mute")}
              //   classes={{ tooltip: classes.tooltipFont }}
              // >
              //   <IconButton
              //     className={classes.buttonOption}
              //     aria-label="delete"
              //     id={
              //       data.patient
              //         ? `clear-alert-${data.patient.hn}`
              //         : `clear-alert-${data.roomName}`
              //     }
              //     onClick={() => this.clearAlert(data)}
              //   >
              //     <Icons.NotificationsOff color="primary" />
              //   </IconButton>
              // </Tooltip>
            )}
          {data.alert && data.alert.acknowledge === true && (
            <Tooltip title={t('acknowledge')} classes={{ tooltip: classes.tooltipFont }}>
              <IconButton
                className={classes.buttonOption}
                aria-label='delete'
                id={data.patient ? `acknowledge-alert-${data.patient.hn}` : `acknowledge-alert-${data.roomName}`}
                onClick={() => this.acknowledge(data)}
              >
                <svg width='21' height='21' viewBox='4 0 14 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M6.5 11L9 14L15.5 6' stroke='#00978F' strokeWidth='1.5' />
                </svg>
              </IconButton>
            </Tooltip>
            // <Tooltip
            //   title={t("acknowledge")}
            //   classes={{ tooltip: classes.tooltipFont }}
            // >
            //   <IconButton
            //     className={classes.buttonOption}
            //     aria-label="delete"
            //     id={
            //       data.patient
            //         ? `acknowledge-alert-${data.patient.hn}`
            //         : `acknowledge-alert-${data.roomName}`
            //     }
            //     onClick={() => this.acknowledge(data)}
            //   >
            //     <Icons.HowToReg color="primary" />
            //   </IconButton>
            // </Tooltip>
          )}
        </div>
      );
    }
  };

  render() {
    const { data, key, showTable, classes } = this.props;
    const room = data.roomName && data.name ? `${data.roomName}/${data.name}` : data.roomName || data.name;

    let customStyle = {
      padding: 5,
      textAlign: 'center',
      width: '280px',
      fontSize: 14,
      color: 'white',
    };

    const alert = voteAlert(data.patient);
    const { votedAlert, hasEmergencyDevice, hasEmergencyAlert } = alert;

    if (votedAlert) {
      switch (votedAlert.alertCritical === 'true' ? 'critical' : votedAlert.alertWarning === 'true' ? 'warning' : '') {
        case 'warning':
          if (
            votedAlert.alertType === 503 ||
            votedAlert.alertType === 504 ||
            votedAlert.alertType === 512 ||
            votedAlert.alertType === 513
          ) {
            customStyle = { ...customStyle, backgroundColor: '#10b0c3' };
          } else {
            customStyle = {
              ...customStyle,
              backgroundColor: '#FEB84F',
              color: '#4A4A4A',
            };
          }
          break;
        case 'critical':
          customStyle = {
            ...customStyle,
            backgroundColor: '#EB5861',
          };
          break;
        default:
          customStyle = { ...customStyle };
          break;
      }
    }

    return (
      <React.Fragment>
        <TableRow key={key} className={classes.bodyTable}>
          <TableCell className={classes.tableCell} component='th' scope='row'>
            {showTable.seeBoxColor && hasEmergencyDevice && !hasEmergencyAlert ? (
              <div className={classes.iconsos}>
                {/* <img src={iconSOSGray} alt="sos" width="30" /> */}
                <svg width='26' height='26' viewBox='0 0 47 45'>
                  <use xlinkHref={`/images/sos-v4.svg#sosgray`} />
                </svg>
              </div>
            ) : (
              hasEmergencyDevice &&
              hasEmergencyAlert && (
                <div className={classes.iconsos}>
                  {/* <img src={iconSOS} alt="sos" width="30" /> */}
                  <svg width='26' height='26' viewBox='0 0 47 45'>
                    <use xlinkHref={`/images/sos-v4.svg#sos`} />
                  </svg>
                </div>
              )
            )}
          </TableCell>
          {showTable.seeHN && (
            <TableCell className={classes.tableCellHiding} align='left'>
              {data.patient ? data.patient.hn : ''}
            </TableCell>
          )}
          {showTable.seeName && (
            <TableCell className={classes.tableCell} align='left'>
              {this.getColFullname(data.patient)}
            </TableCell>
          )}
          {config.features.dashboard.roomName && showTable.seeRoom && (
            <TableCell className={classes.tableCellHiding} component='th' scope='row'>
              {room}
            </TableCell>
          )}
          {showTable.seeStatus && (
            <TableCell className={classes.tableCell} align='left'>
              {this.getColStatus(data)}
            </TableCell>
          )}
          {showTable.seeAlert && (
            <TableCell className={classes.tableCell} align='left'>
              {this.getColAlert(data, votedAlert, customStyle)}
            </TableCell>
          )}
          {showTable.seeAlertTime && (
            <TableCell className={classes.tableCell} align='left'>
              {this.getColAlertTime(votedAlert)}
            </TableCell>
          )}
          {showTable.seeOption && localStorage.getItem('role') !== 'Security Guard' && (
            <TableCell className={classes.tableCellOptions}>
              {this.getColOptions(data)}
              {/* {this.getColOptionsSecurityGuard(data)} */}
            </TableCell>
          )}
        </TableRow>
      </React.Fragment>
    );
  }
}

export const page = inject('dashboard', 'area', 'router')(observer(ContentRow));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
